import React, { useContext, useMemo } from "react";

import _ from "lodash";
import cx from 'classnames';

import { Assessment } from "src/types/coaching/courses";
import { LearningRecordCourse } from "src/types/coaching/learners";
import { CourseContext } from "../../../context";

import Button from "src/components/button";

import styles from "./assessment.module.scss";

interface ViewAssessmentContentProps {
  course: LearningRecordCourse;
  assessment: Assessment;
  collapsed: boolean
}

export const ViewAssessmentContent: React.FC<ViewAssessmentContentProps> = ({ course, assessment, collapsed }) => {
  const courseContext = useContext(CourseContext);

  const name = useMemo(() => {
    return _.get(assessment, "name");
  }, [assessment]);

  const { creating, fetching, fetchingReport, session, status } = useMemo(() => {
    
    const item = courseContext?.courseContentSession;

    const creating = _.get(item, "creating") || false;
    const fetching = _.get(item, "fetching") || false;
    const fetchingReport = _.get(item, "fetchingReport") || false;

    const session = _.get(item, "session");
    const status = _.get(item, "status");

    return {
      creating,
      fetching,
      fetchingReport,
      session,
      status,
    }
  }, [courseContext?.courseContentSession]);

  const handleStartAssessment = () => {
    if(courseContext.createCourseContentSession) {
      courseContext.createCourseContentSession(assessment);
    }
  }

  const handleResumeAssessment = () => {
    if(courseContext.fetchCourseContentSession && session) {
      courseContext.fetchCourseContentSession(assessment, session);
    }
  }

  const handleViewReport = () => {
    if(courseContext.fetchAssessmentReport && session) {
      courseContext.fetchAssessmentReport(assessment, session);
    }
  }

  return (
    <div className={cx(styles.editContainer, {
      [styles.collapsed]: collapsed
    })}>
      <div className={styles.header}>
        <p className={styles.name}>{name}</p>
      </div>

      <div className={styles.assessmentDetails}>
        <div className={styles.messageContainer}>
          <img
            className={styles.image}
            src="/images/coaching/start_assessment.svg"
            alt="start assessment"
          />
          <p className={styles.message}>
            This assessment{" "}
            <span className={styles.bold}>{assessment.name}</span> has
            <span className={styles.bold}>
              {" "}
              {assessment.questions.length}
            </span>{" "}
            questions totally.
          </p>
        </div>

        <div>
          {session && status != 'COMPLETED' && (
            <Button
              variant="secondary"
              icon="paperflite-right-arrow"
              text={fetching ? 'Preparing Assessment...' : 'Resume Assessment'}
              disabled={fetching}
              onClick={handleResumeAssessment}
              className={styles.fetchReport}
            ></Button>
          )}
          {!session && status != 'COMPLETED' && (
            <Button
              variant="primary"
              icon="paperflite-right-arrow"
              text={creating ? 'Starting...' : 'Start Assessment'}
              disabled={creating}
              onClick={handleStartAssessment}
              className={styles.startAssessment}
            ></Button>
          )}

          {session && status == 'COMPLETED' && (
            <Button
              variant="secondary"
              icon="paperflite-right-arrow"
              text={fetchingReport ? 'Fetching Report...' : 'View Report'}
              disabled={fetchingReport}
              onClick={handleViewReport}
              className={styles.fetchReport}
            ></Button>
          )}
        </div>
      </div>
    </div>
  );
}